import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import store from "@/store/store";

class MedicoController {
  private static getNrOrg(): string {
    return store.getters.user.nrorg;
  }

  public static async cadastrarMedico(medico: any): Promise<any> {
    try {
      const route = 'setPessoa';
      const nrOrg = this.getNrOrg();

      // Garantir que o NRORG está definido
      medico.NRORG = nrOrg;

      // Definir a data de vigência como 01/01/2000 conforme solicitado
      medico.DTINIVIGENCIA = medico.DTINIVIGENCIA || '01/01/2000';

      // Marcar como novo registro
      medico.__is_new = true;

      const params = {
        requestType: 'Row',
        NRORG: store.getters.user.nrorg,
        row: medico
      };

      const response = await HttpRequest.post(route, params, true);

      if (response.data.error) {
        throw new Error(response.data.error.message || 'Erro ao cadastrar médico');
      }

      if (response.data.messages && response.data.messages.length > 0) {
        const message = response.data.messages[0].message;
        if (response.data.messages[0].type === 'error') {
          throw new Error(message);
        } else {
          SnackbarUtils.showMessage(message, 'success');
        }
      }

      // Verificar diferentes formatos de resposta para requestType: 'Row'
      if (response.data.dataset && response.data.dataset.data && response.data.dataset.data.length > 0) {
        return response.data.dataset.data[0];
      }

      // Manter compatibilidade com formato atual se necessário
      if (response.data.dataset && response.data.dataset.columnsToReturn && response.data.dataset.columnsToReturn.length > 0) {
        return response.data.dataset.columnsToReturn[0];
      }

      return null;
    } catch (e) {
      const err = e as any;
      // Tratamento de erros mais específico
      let message = 'Erro ao cadastrar médico';

      if (err.response && err.response.data && err.response.data.error) {
        message = err.response.data.error.message || err.response.data.error;
      } else if (err.message) {
        message = err.message;
      }

      message.replace('(HCMSERVICES) ', '');
      SnackbarUtils.showMessage(message, 'error');
      throw err;
    }
  }

  public static async getPessoaConselhoReg(): Promise<any[]> {
    try {
      const route = 'getPessoaConselhoReg';
      const nrOrg = this.getNrOrg();

      const params = {
        requestType: 'FilterData',
        NRORG: nrOrg,
      };

      const response = await HttpRequest.get(route, params, false);

      if (typeof response.data === 'string') {
        throw new Error(response.data);
      }

      const rows =
        response.data.dataset.data ||
        response.data.dataset[route] ||
        [];

      return rows;
    } catch (err) {
      const message = 'Erro ao buscar médicos';
      SnackbarUtils.showMessage(message, 'error');
      throw err;
    }
  }

  public static async verificarMedicoExistente(cpf: string): Promise<boolean> {
    try {
      const medicos = await this.getPessoaConselhoReg();
      return medicos.some(medico => medico.NRCPFPESSOA === cpf);
    } catch (err) {
      return false;
    }
  }
}

export { MedicoController };
